import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import TransporterService from "../../../services/TransporterService";
import Breadcrumb from "../../../components/Breadcrumb";
import StorageService from "../../../services/StorageService";
import ListTransporter from "../Components/ListTransporter";
import ViewModelTransporter from "../Components/ViewModelTransporter";
import MessageDialog from "../../../components/MessageDialog";

export default function ViewTransporters() {
    const [transporters, setTransporters] = useState([]);
    const [selected, setSelected] = useState(null); // single select (radio)
    const [searchTerm, setSearchTerm] = useState(""); // search
    const [message, setMessage] = useState("");
    const [msgType, setMsgType] = useState("success");
    // const messageTimer = useRef(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [showViewModal, setShowViewModal] = useState(false);

    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20;

    const [viewData, setViewData] = useState(null);

    const showMessage = (text, type = "success") => {
        setMessage(text);
        setMsgType(type);
        // if (messageTimer.current) clearTimeout(messageTimer.current);
        // messageTimer.current = setTimeout(() => setMessage(""), 4000);
    };

    // const closeMessage = () => {
    //     setMessage("");
    //     if (messageTimer.current) clearTimeout(messageTimer.current);
    // };

    //    const fetchTransporters = async () => {
    //   setLoading(true);
    //   try {
    //     const res = await TransporterService.getActiveTransporters();

    //     const list = Array.isArray(res)
    //       ? res
    //       : Array.isArray(res?.data)
    //       ? res.data
    //       : [];

    //     // 🔹 FRONTEND PAGINATION
    //     const startIndex = (currentPage - 1) * itemsPerPage;
    //     const endIndex = startIndex + itemsPerPage;
    //     const paginatedList = list.slice(startIndex, endIndex);

    //     setTransporters(paginatedList);
    //     setPageCount(Math.ceil(list.length / itemsPerPage));
    //   } catch (error) {
    //     console.error("Transporter load error:", error);
    //     showMessage("Failed to load transporters", "error");
    //   } finally {
    //     setLoading(false);
    //   }
    // };


    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    const fetchTransporters = async () => {
        setLoading(true);
        try {
            const res = await TransporterService.getTransporters(currentPage, itemsPerPage, searchTerm);

            const list = Array.isArray(res?.data) ? res.data : [];
            setTransporters(list);
            setPageCount(res.totalPages || 1);
        } catch (error) {
            console.error("Transporter load error:", error);
            showMessage("Failed to load transporters", "error");
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchTransporters();
    }, [currentPage, searchTerm]);




    const handleAdd = () => navigate("/cpnl/transporters/add");

    const handlePageClick = (event) => {
        const selectedPage = event.selected + 1;
        setCurrentPage(selectedPage);
    };


    const handleModify = () => {
        if (!selected) {
            showMessage("Please select a transporter to modify.", "error");
            return;
        }

        if (selected.status !== "Active") {
            showMessage("Inactive transporters cannot be modified.", "error");
            return;
        }

        navigate(`/cpnl/transporters/add/${selected.id}`);
    };

    const handleView = async () => {
        if (!selected) {
            showMessage("Please select a transporter to view.", "error");
            return;
        }

        try {
            setLoading(true);
            const res = await TransporterService.getById(selected.id);
            const data = res?.data?.data || res?.data || res;

            if (!data) {
                showMessage("Failed to load transporter details!", "error");
                return;
            }

            setViewData(data);
            setShowViewModal(true);
        } catch (err) {
            console.error(err);
            showMessage("Error loading transporter details.", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleToggleStatus = async (id) => {
        const transporter = transporters.find((v) => v.id === id);
        if (!transporter) return;

        const confirmMsg =
            transporter.status === "Active"
                ? "Are you sure you want to change status to Inactive?"
                : "Are you sure you want to change status to Active?";

        if (!window.confirm(confirmMsg)) return;

        setLoading(true);
        try {
            await TransporterService.updateStatus(id);
            showMessage(
                transporter.status === "Active"
                    ? "Transporter inactivated successfully!"
                    : "Transporter activated successfully!",
                "success"
            );
            fetchTransporters();
        } catch (error) {
            console.error(error);
            showMessage("Error updating transporter status.", "error");
        } finally {
            setLoading(false);
        }
    };

    const closeViewModal = () => {
        setShowViewModal(false);
        setViewData(null);
    };

    const filteredTransporters = transporters;


    return (
        <>
            <Breadcrumb pageTitle="transporters" secondTitle="Masters"></Breadcrumb>
            <div className="row">
                <div className="card py-2 bg-white shadow-sm">
                    {/* {message && (
                        <div
                            className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                                } d-flex justify-content-between align-items-center mb-2 p-2`}
                        >
                            <span>{message}</span>
                            <button type="button" className="btn-close" onClick={closeMessage}></button>
                        </div>
                    )} */}
                    
                        <MessageDialog
                            message={message}
                            type={msgType}
                            setMessage={setMessage}
                            setMsgType={setMsgType}
                        />
                    

                    {/* TOP BUTTONS */}
                    <div className="mb-3 pb-2 border-bottom d-flex align-items-end gap-3">
                        <div>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search transporter"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>

                        <div className="ms-auto d-flex gap-2">
                            <button className="btn btn-success" onClick={handleAdd} disabled={loading}>
                                <i className="ti ti-plus me-1"></i> Add
                            </button>

                            <button className="btn btn-warning" onClick={handleModify} disabled={loading}>
                                <i className="ti ti-pencil me-1"></i> Modify
                            </button>

                            <button className="btn btn-primary" onClick={handleView} disabled={loading}>
                                <i className="ti ti-eye me-1"></i> View
                            </button>
                        </div>
                    </div>

                    <ListTransporter
                        loading={loading}
                        filteredTransporters={filteredTransporters}
                        selected={selected}
                        setSelected={setSelected}
                        handleToggleStatus={handleToggleStatus}
                        pageCount={pageCount}
                        handlePageClick={handlePageClick}
                    />
                </div>
            </div>

            <ViewModelTransporter
                showViewModal={showViewModal}
                viewData={viewData}
                closeViewModal={closeViewModal}
            />
        </>
    );
}
